export const createChatRoutes = (basePath: string) =>
  ({
    index: basePath,
  }) as const;
